const promotion = {
  page: {
    opening: "فتح مركز الترويج",
    loading: "جارٍ التحقق من الجلسة وتحميل بيانات الحملات.",
    notice: "تنبيه",
    errors: {
      settings: "تعذر تحميل إعدادات التنظيم.",
      initialize: "تعذر تهيئة مركز الترويج.",
    },
  },
  center: {
    campaignWorkspace: "مساحة عمل الحملات",
    aiStudio: "استوديو الترويج بالذكاء الاصطناعي",
  },
  common: {
    refresh: "تحديث",
    optional: "اختياري",
    unknown: "غير معروف",
    unknownType: "نوع غير معروف",
    unknownBot: "بوت غير معروف",
    unknownChannel: "غير معروف",
    bot: "البوت:",
    roles: { superAdmin: "مشرف عام", admin: "مشرف" },
    created: "أُنشئت {{date}}",
    createdBy: "أُنشئت {{date}} بواسطة {{username}}",
    startedCompleted: "بدأت {{started}} · اكتملت {{completed}}",
    checked: "تم الفحص {{date}}",
    total: "{{count}} إجمالي",
    viewAll: "عرض الكل",
    cancel: "إلغاء",
    delete: "حذف",
    enable: "تفعيل",
    disable: "تعطيل",
    add: "إضافة",
    status: {
      draft: "مسودة",
      ready: "جاهز",
      running: "قيد التشغيل",
      completed: "مكتملة",
      partial: "جزئي",
      failed: "فشل",
      cancelled: "ملغاة",
    },
    contentMode: {
      original: "الأصل",
      teaser: "تشويقي",
      ai: "مجهز بالذكاء الاصطناعي",
      custom: "مخصص",
    },
    deliveryStatus: {
      pending: "معلق",
      in_progress: "قيد التنفيذ",
      success: "نجاح",
      failed: "فشل",
      skipped: "تم التجاوز",
    },
    chatType: {
      channel: "قناة",
      group: "مجموعة",
      supergroup: "مجموعة فائقة",
    },
  },
  workspace: {
    loadingTitle: "جارٍ تحميل مركز الترويج",
    loadingDescription: "جارٍ مزامنة الحملات والوجهات وسجل التسليم.",
    heroEyebrow: "مركز الترويج",
    heroTitle: "مساحة توزيع الحملات",
    heroDescription: "حوّل المنشورات المجمّعة إلى حملات ترويج مضبوطة، وانشرها إلى قنوات ومجموعات تيليجرام التي تم التحقق منها، وأعد فقط الوجهات الفاشلة.",
    loadErrorTitle: "تعذر تحميل بيانات الترويج",
    tabs: {
      overview: "نظرة عامة",
      campaigns: "الحملات",
      create: "إنشاء حملة",
      targets: "وجهات الترويج",
      history: "سجل التسليم",
    },
    stats: {
      campaigns: "الحملات",
      active: "نشطة",
      completed: "مكتملة",
      attention: "تحتاج إلى اهتمام",
    },
    recent: {
      title: "الحملات الأخيرة",
      description: "أحدث نشاط ترويجي وحالة الحملات.",
      emptyTitle: "لا توجد حملات بعد",
      emptyDescription: "أنشئ أول حملة ترويج من منشورات تيليجرام المجمّعة.",
      create: "إنشاء حملة",
    },
    readiness: {
      title: "جاهزية الوجهات",
      summary: "وجهات تم التحقق منها ومتاحة لإطلاق الحملة",
      ready: "جاهز",
      blocked: "محظور",
      empty: "لم يتم إعداد وجهات ترويج بعد.",
      review: "مراجعة الوجهات ←",
    },
    create: {
      title: "إنشاء حملة ترويج",
      description: "أنشئ هيكل الحملة أولًا. بعد ذلك اختر المنشورات، وأعد النص، وحدد الوجهات، ثم أطلق الحملة من مساحة العمل.",
      name: "اسم الحملة",
      namePlaceholder: "مثال: ملخص التكنولوجيا الأسبوعي",
      descriptionLabel: "الوصف",
      descriptionPlaceholder: "ملاحظات الحملة الداخلية، الهدف، الجمهور…",
      draftNote: "الحملات begin as مسودة. No Telegram messages are sent until you explicitly select verified targets and confirm launch.",
      action: "إنشاء حملة",
    },
    campaigns: {
      title: "الحملات",
      empty: "لا توجد حملات بعد.",
      selectTitle: "اختر حملة",
      selectDescription: "افتح حملة من القائمة لإعدادها ونشرها.",
      markReady: "وضع علامة جاهزة",
      backDraft: "إرجاع إلى مسودة",
      deleteAria: "حذف الحملة {{name}}",
      deliveries: "عمليات التسليم",
      succeeded: "نجح",
      failed: "فشل",
      warnings: "تحذيرات",
    },
    posts: {
      addTitle: "إضافة منشور مجمّع",
      searchPlaceholder: "ابحث في المنشورات المجمعة بالقناة أو المعرّف أو النص…",
      select: "اختر منشورًا مجمّعًا (المعروض {{count}})",
      aiNote: "AI mode uses prepared copy from استوديو الترويج بالذكاء الاصطناعي or manually entered copy.",
      contentMode: "وضع المحتوى",
      promotionText: "نص الترويج",
      aiPlaceholder: "أدخل هنا نص الترويج المُعد بالذكاء الاصطناعي.",
      textPlaceholder: "اكتب النسخة الترويجية من هذا المنشور…",
      cta: "دعوة لاتخاذ إجراء",
      ctaPlaceholder: "اقرأ المزيد / انضم إلى القناة…",
      sourceLink: "تجاوز رابط المصدر",
      save: "حفظ النص",
      originalTitle: "المنشور الأصلي المجمّع",
      sourceUnavailable: "المنشور المصدر غير متاح.",
      preview: "معاينة تيليجرام",
      copyNotReady: "نص الترويج غير جاهز بعد.",
      emptyTitle: "لا تحتوي الحملة على منشورات",
      emptyDescription: "أضف منشورًا مجمّعًا واحدًا أو أكثر قبل اختيار وجهات الترويج.",
      editAria: "تحرير منشور الحملة",
      removeAria: "إزالة منشور الحملة",
    },
    launch: {
      title: "اختر وجهات الترويج",
      description: "يمكن اختيار الوجهات المفعلة والتي تم التحقق منها فقط. فشل وجهة واحدة لا يمنع نجاح الوجهات الأخرى.",
      verified: "تم التحقق",
      noTargets: "لا توجد وجهات ترويج بعد. يجب على المشرف العام إعداد وجهة واحدة على الأقل والتحقق منها قبل إطلاق الحملة.",
      running: "هذه الحملة قيد التشغيل بالفعل. يستخدم الاستئناف مجموعة الوجهات الأصلية المحفوظة على الخادم.",
      selected_zero: "لم يتم اختيار أي وجهة",
      selected_one: "تم اختيار وجهة واحدة",
      selected_two: "تم اختيار وجهتين",
      selected_few: "تم اختيار {{formattedCount}} وجهات",
      selected_many: "تم اختيار {{formattedCount}} وجهة",
      selected_other: "تم اختيار {{formattedCount}} وجهة",
      posts_zero: "لا توجد منشورات حملة",
      posts_one: "منشور حملة واحد",
      posts_two: "منشورا حملة",
      posts_few: "{{formattedCount}} منشورات حملة",
      posts_many: "{{formattedCount}} منشور حملة",
      posts_other: "{{formattedCount}} منشور حملة",
      deliveries: "حتى {{count}} عملية تسليم",
      confirmHint: "اضغط مرة أخرى لتأكيد النشر",
      confirm: "تأكيد الإطلاق",
      launch: "إطلاق الحملة",
    },
    delivery: {
      title: "تقرير التسليم",
      description: "نتيجة كل وجهة وسجل تدقيق محاولات الإعادة.",
      retrySelected: "إعادة المحدد ({{count}})",
      retryAll: "إعادة كل العمليات الفاشلة",
      headers: {
        status: "الحالة",
        post: "المنشور",
        target: "الوجهة",
        attempts: "المحاولات",
        result: "النتيجة",
      },
      lastAttempt: "آخر محاولة {{date}}",
      success: "تم النشر بنجاح",
    },
    targets: {
      addTitle: "إضافة وجهة للحملة",
      addDescription: "أضف قناة أو مجموعة تيليجرام التي يمكن للحملات النشر إليها. يلزم اختبار الاتصال قبل أن تصبح الوجهة قابلة للاختيار.",
      name: "اسم الوجهة",
      namePlaceholder: "قناة أخبار شريكة",
      chatId: "معرّف محادثة تيليجرام / @username",
      chatIdPlaceholder: "@channel or -100…",
      chatType: "نوع المحادثة",
      publishingBot: "بوت النشر",
      selectBot: "اختر حساب البوت",
      disabledSuffix: "معطل",
      credentialMissingSuffix: "بيانات الاعتماد مفقودة",
      botHelp: "يجب أن يكون البوت عضوًا/مسؤولًا في الوجهة ولديه صلاحية النشر.",
      add: "إضافة وجهة",
      registerHelp: "احفظ رمز بوتك الشخصي في «الوجهات»، ثم سجّل البوت لمساحة حملاتك الخاصة.",
      register: "تسجيل بوت الوجهات الخاص بي",
      listTitle: "وجهات الحملات",
      listDescription: "هذه القنوات والمجموعات هي مجموعة الوجهات المعروضة عند إطلاق الحملة.",
      summary: "{{verified}} تم التحقق منها · {{total}} إجمالي",
      ready: "جاهزة للحملات",
      needsVerification: "تحتاج إلى تحقق",
      connectionError: "خطأ في الاتصال",
      disabled: "معطلة",
      typeNotVerified: "النوع غير متحقق",
      retest: "إعادة الاختبار",
      test: "اختبار الاتصال",
      emptyTitle: "لا توجد وجهات حملة مُعدّة",
      emptyDescription: "أضف إحدى قنواتك أو مجموعاتك في تيليجرام أعلاه ثم اختبر الاتصال.",
    },
    history: {
      title: "سجل التسليم",
      description: "يتم الاحتفاظ بالحملات المكتملة والجزئية والفاشلة كسجل تدقيق. افتح حملة لمراجعة محاولات التسليم الفردية.",
      emptyTitle: "لا يوجد سجل تسليم بعد",
      emptyDescription: "ستظهر نتائج الحملات هنا بعد أول إطلاق.",
    },
    feedback: {
      refreshed: "تم تحديث مساحة عمل الترويج.",
      loadFailed: "تعذر تحميل بيانات الترويج.",
      campaignLoadFailed: "تعذر تحميل الحملة.",
      nameRequired: "اسم الحملة مطلوب.",
      created: "تم إنشاء حملة الترويج.",
      createFailed: "تعذر إنشاء الحملة.",
      marked: "تم تعيين حالة الحملة إلى «{{status}}».",
      updateFailed: "تعذر تحديث الحملة.",
      deleteConfirm: "حذف الحملة المسودة «{{name}}»؟",
      deleted: "تم حذف الحملة.",
      deleteFailed: "تعذر حذف الحملة.",
      choosePost: "اختر منشورًا مجمّعًا أولًا.",
      postAdded: "تمت إضافة المنشور إلى حملة الترويج.",
      attachFailed: "تعذر إرفاق المنشور.",
      modeNeedsText: "وضع {{mode}} يتطلب نص ترويج قبل الإطلاق.",
      copySaved: "تم حفظ نص الترويج.",
      copySaveFailed: "تعذر تحديث نص الترويج.",
      removePostConfirm: "إزالة هذا المنشور من الحملة؟",
      postRemoved: "تمت إزالة المنشور من الحملة.",
      removePostFailed: "تعذر إزالة منشور الحملة.",
      botRegistered: "أصبح بوت الوجهات المحفوظ متاحًا لحملاتك الشخصية.",
      botRegisterFailed: "تعذر تسجيل بوت الوجهات للحملات.",
      targetRequired: "اسم الوجهة ومعرّف محادثة تيليجرام وحساب البوت مطلوبة.",
      targetCreated: "تم إنشاء وجهة الترويج. اختبر الاتصال قبل استخدامها في الحملة.",
      targetCreateFailed: "تعذر إنشاء وجهة الترويج.",
      targetVerified: "تم التحقق من وجهة الترويج وأصبحت جاهزة للحملات.",
      targetVerificationFailed: "فشل التحقق من وجهة الترويج.",
      targetEnabled: "تم تفعيل وجهة الترويج.",
      targetDisabled: "تم تعطيل وجهة الترويج.",
      targetUpdateFailed: "تعذر تحديث وجهة الترويج.",
      targetDeleteConfirm: "حذف وجهة الترويج «{{name}}»؟ سيُمنع الحذف إذا كانت مطلوبة للاحتفاظ بسجل التسليم لأغراض التدقيق.",
      targetDeleted: "تم حذف وجهة الترويج.",
      targetDeleteFailed: "تعذر حذف وجهة الترويج.",
      selectTarget: "اختر وجهة ترويج واحدة على الأقل تم التحقق منها.",
      delivered: "تم تسليم حملة الترويج بنجاح.",
      deliveryResults: "انتهت الحملة بنتائج تسليم. راجع التقرير أدناه.",
      launchFailed: "تعذر إطلاق حملة الترويج.",
      selectFailed: "اختر عمليات التسليم الفاشلة لإعادة المحاولة.",
      retryFinished: "اكتملت إعادة المحاولة. تم تحديث تقرير التسليم.",
      retryFailed: "تعذر إعادة عمليات التسليم الفاشلة.",
      sessionChanged: "تغيرت الجلسة. أعد فتح مساحة العمل.",
      requestFailed: "فشل طلب الترويج ({{status}}).",
    },
  },
  ai: {
    loading: "جارٍ تحميل استوديو الترويج بالذكاء الاصطناعي",
    heroEyebrow: "محرك الترويج بالذكاء الاصطناعي",
    heroTitle: "أنشئ وراجع ثم احفظ",
    heroDescription: "Generate promotion-specific copy with the configured Gemini or OpenRouter model. النتيجةs stay editable and are never published automatically.",
    operationFailed: "فشلت عملية الذكاء الاصطناعي",
    campaignPost: "منشور الحملة",
    campaign: "الحملة",
    selectCampaign: "اختر حملة",
    post: "المنشور",
    selectPost: "اختر منشور الحملة",
    campaignState: "حملة {{status}} · {{editing}} · الدور {{role}}",
    editingEnabled: "تحرير الذكاء الاصطناعي مفعّل",
    readOnly: "للقراءة فقط بعد بدء النشر",
    generationControls: "عناصر التحكم في الإنشاء",
    action: "إجراء الذكاء الاصطناعي",
    writingStyle: "أسلوب الكتابة",
    outputLanguage: "لغة الإخراج",
    outputLanguagePlaceholder: "الإنجليزية",
    extraInstructions: "تعليمات إضافية",
    instructionsPlaceholder: "الجمهور، نقاط التركيز، الطول المفضل…",
    generate: "إنشاء {{action}}",
    backendNote: "يتم تحديد المزود ومفاتيح API على الخادم من إعداد الذكاء الاصطناعي الحالي. يُعامل النص المصدر كمادة غير موثوقة وليس كتعليمات للنموذج.",
    generatedTitle: "النتيجة المُنشأة",
    generatedDescription: "راجع النتيجة قبل تطبيقها على نص الحملة.",
    generatedPlaceholder: "سيظهر ناتج الذكاء الاصطناعي هنا…",
    apply: "تطبيق النتيجة في المحرر",
    editorTitle: "محرر نص الحملة",
    editorDescription: "هذا هو النص الذي سيُحفظ للنشر لاحقًا على تيليجرام.",
    contentMode: "وضع المحتوى",
    promotionText: "نص الترويج",
    cta: "دعوة لاتخاذ إجراء",
    ctaPlaceholder: "اقرأ المزيد / انضم إلى القناة…",
    save: "حفظ في الحملة",
    preview: "معاينة تيليجرام",
    previewEmpty: "اختر منشور الحملة لمعاينة نص الترويج النهائي.",
    styles: {
      professional: "احترافي",
      news: "أخباري",
      educational: "تعليمي",
      friendly: "ودود",
      casual: "غير رسمي",
      marketing: "تسويقي",
      viral: "قابل للانتشار",
    },
    actions: {
      teaser: { label: "تشويقي", help: "أنشئ مقدمة موجزة ومشوقة دون عناوين مضللة." },
      rewrite: { label: "إعادة صياغة ترويجية", help: "حوّل المصدر أو المسودة الحالية إلى نص ترويجي مصقول." },
      shorten: { label: "اختصار", help: "اختصر النص مع الحفاظ على الحقائق الأساسية." },
      expand: { label: "توسيع", help: "حسّن البنية والشرح دون اختلاق حقائق جديدة." },
      translate: { label: "ترجمة", help: "ترجم بأمانة مع الحفاظ على الروابط والأسماء والتنسيق." },
      cta: { label: "إنشاء دعوة لاتخاذ إجراء", help: "أنشئ دعوة قصيرة واحدة لاتخاذ إجراء لمنشور الحملة." },
      hashtags: { label: "إنشاء وسوم", help: "أنشئ 3–6 وسوم تيليجرام ذات صلة." },
    },
    feedback: {
      selectPost: "اختر منشور الحملة أولًا.",
      editableOnly: "AI generation is available only for مسودة or جاهز campaigns.",
      chooseLanguage: "اختر اللغة المستهدفة للترجمة.",
      generated: "تم إنشاء {{action}}. راجعه قبل التطبيق.",
      generationFailed: "فشل إنشاء المحتوى بالذكاء الاصطناعي.",
      applied: "تم تطبيق النتيجة المُنشأة على نص الحملة القابل للتحرير.",
      editOnly: "يمكن تحرير منشورات الحملات التي تكون حالتها «مسودة» أو «جاهز» فقط.",
      modeNeedsText: "وضع {{mode}} يتطلب نص ترويج.",
      saved: "تم حفظ نص الترويج المدعوم بالذكاء الاصطناعي في الحملة.",
      saveFailed: "تعذر حفظ نص الترويج.",
      loadFailed: "تعذر تحميل استوديو الترويج بالذكاء الاصطناعي.",
      campaignLoadFailed: "تعذر تحميل الحملة.",
      sessionChanged: "تغيرت الجلسة. أعد فتح مساحة العمل.",
      requestFailed: "فشل طلب ذكاء اصطناعي الترويج ({{status}}).",
    },
  },
} as const;

export default promotion;
